import { RefObject, useCallback, useState } from 'react';

export default function useStateWithFocusRef<T>(initialValue: T, ref: RefObject<HTMLElement>) {
	const [value, _setValue] = useState<T>(initialValue);
	const setValue = useCallback(
		(v: T) => {
			_setValue(v);
			ref.current?.focus();
		},
		[ref]
	);

	return [value, setValue] as const;
}
